<template>
  <div>
    <h2>Lugar de Nacimiento</h2>
    <app-ubigeo
      ref="ubigeo"
      :regions="regions"
      :provinces="provinces"
      :districts="districts"
      @changed="ubigeoCambiado"
    />
    <v-layout wrap>
      <v-flex
        xs12
        md6
      >
        <v-autocomplete
          v-model="form.language_id"
          :items="languages"
          label="SELECCIONAR IDIOMA"
          item-text="title"
          item-value="id"
          :rules="rules.language_id"
          :error="!!formErrors.language_id"
          :error-messages="formErrors.language_id"
          @keyup="
            () => {
              formErrors.language_id = undefined;
              delete formErrors.language_id;
            }
          "
        />
      </v-flex>
      <v-flex
        xs12
        md6
      >
        <div style="display:flex">
          <v-checkbox
            v-model="form.reading"
            :label="`LEE`"
          />
          <v-checkbox
            v-model="form.speaking"
            :label="`HABLA`"
          />
          <v-checkbox
            v-model="form.writing"
            :label="`ESCRIBE`"
          />
        </div>
      </v-flex>
      <v-flex
        v-if="amazonic"
        xs12
        md6
      >
        <v-autocomplete
          v-model="form.extra"
          :items="extraExams"
          label="SELECCIONAR ANDINO AMAZONICO"
          @change="community"
        />
      </v-flex>
      <v-flex
        v-if="amazonic"
        xs12
        md6
      >
        <v-autocomplete
          v-model="form.community_id"
          :items="communities"
          item-text="name"
          item-value="id"
          label="TIPO DE COMUNIDAD"
        />
      </v-flex>
      <v-flex
        sm8
        xs12
      >
        <v-text-field
          v-model="form.legal_representative"
          label="NOMBRES DEL APODERADO"
          value="legal_representative"
          :rules="rules.legal_representative"
          :error="!!formErrors.legal_representative"
          :error-messages="formErrors.legal_representative"
          @keyup="
            () => {
              formErrors.legal_representative = undefined;
              delete formErrors.legal_representative;
            }
          "
        />
      </v-flex>
      <v-flex
        sm4
        xs12
      >
        <v-text-field
          v-model="form.telephone_legal_representative"
          type="number"
          label="CELULAR DEL APODERADO"
          :rules="rules.telephone_legal_representative"
          :error="!!formErrors.telephone_legal_representative"
          :error-messages="
            formErrors.telephone_legal_representative
          "
          @keyup="
            () => {
              formErrors.telephone_legal_representative = undefined;
              delete formErrors.telephone_legal_representative;
            }
          "
        />
      </v-flex>
      <v-flex
        sm3
        xs12
      >
        <v-autocomplete
          v-model="form.graduate_year"
          :items="years"
          label="AÑO DE QUE EGRESO DE LA SECUNDARIA"
          :rules="rules.graduate_year"
          :error="!!formErrors.graduate_year"
          :error-messages="formErrors.graduate_year"
          @keyup="
            () => {
              formErrors.graduate_year = undefined;
              delete formErrors.graduate_year;
            }
          "
        />
      </v-flex>
      <v-flex
        sm3
        xs12
      >
        <v-text-field
          v-model="form.telephone"
          type="number"
          label="TELÉFONO o CELULAR"
          :rules="rules.telephone"
          :error="!!formErrors.telephone"
          :error-messages="formErrors.telephone"
          @keyup="
            () => {
              formErrors.telephone = undefined;
              delete formErrors.telephone;
            }
          "
        />
      </v-flex>
      <v-flex
        sm6
        xs12
      >
        <v-text-field
          v-model="form.email"
          label="CORREO ELECTRONICO"
          :rules="rules.email"
          :error="!!formErrors.email"
          :error-messages="formErrors.email"
          @keyup="
            () => {
              formErrors.email = undefined;
              delete formErrors.email;
            }
          "
        />
      </v-flex>
    </v-layout>
    <v-flex
      sm12
      xs12
    >
      <label>Señale si tiene alguna discapacidad diagnosticada</label>
      <v-checkbox
        v-model="form.has_disability"
        :label="`Discapacidad`"
      />
      <v-text-field
        v-if="form.has_disability"
        v-model="form.disability"
        label="Cual es su discapacidad"
      />
    </v-flex>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import AppUbigeo from './ubigeo'
import AppUploadFile from './upload-file'

export default {
  name: 'AppLugarNacimiento',
  computed: {
    ...mapState({
      loadingLanguages: state => state.languages.loadingLanguages,
      languages: state => state.languages.languages,
      communities: state => state.typeExams.communities
    }),
    validForm () {
      if (this.pedirRequisitos && !this.form.dni_file_url) {
    	  	this.$message.warning(
          'Debe adjuntar un PDF del DNI conteniendo ambas caras'
        )
        return false
      }

      if (this.pedirRequisitos && !this.form.payment_file_url) {
    	  	this.$message.warning(
          'Debe adjuntar el voucher de pago'
        )
        return false
      }

      return !!this.$refs.ubigeo && !!this.form.legal_representative &&
        !!this.form.telephone_legal_representative &&
        (!this.form.has_disability || this.form.disability)
    }
  },
  components: { AppUbigeo, AppUploadFile },
  created () {
    const currentYear = (new Date()).getFullYear()
    this.years = (new Array(25)).fill(currentYear).map((x, i) => x - i)
  },
  methods: {
    ...mapActions({
      getCommunities: 'typeExams/getCommunities'
    }),

    async community () {
      try {
        let tipo = this.form.extra
        await this.getCommunities({ tipo })
      } catch (error) {
        console.log(error)
      }
    },

    ubigeoCambiado (ubigeo) {
      [this.form.birth_region, this.form.birth_province, this.form.birth_district_id] =
        [ubigeo.region, ubigeo.province, ubigeo.district]
    },
    uploadedDni (data) {
      this.form.dni_file_url = data.url
    },
    uploadedPago (data) {
      this.form.payment_file_url = data.url
    }
  },
  props: { // {{{
    data: {
      required: true, type: Object
    },
    regions: {
      required: true, type: Array
    },
    provinces: {
      required: true, type: Array
    },
    districts: {
      required: true, type: Array
    },
    amazonic: {
      required: false, type: Boolean, default: false
    },
    pedirRequisitos: {
      required: false,
      type: Boolean,
      default: true
    }
  }, // }}}
  data () { // {{{
    return {
      disabled: false,
      formErrors: {},
      formErrores: {},
      extraExams: ['ANDINO', 'AMAZÓNICO'],
      targetIssueDate: false,
      targetIssueDateYear: false,
      dni: {
        title: 'Documento de identidad',
        filePath: '',
        url: ''
      },
      pago: {
        title: 'Voucher de pago',
        filePath: '',
        url: ''
      },
      form: { // {{{
        birth_region: '',
        birth_province: '',
        birth_district_id: '',

        reading: false,
        writing: false,
        speaking: false,
        legal_representative: '',
        telephone_legal_representative: '',
        language_id: '',

        modality_sustenance_url: '',
        dni_file_url: '',
        payment_file_url: '',
        has_disability: false,
        graduate_year: (new Date()).getFullYear() - 1,
        disability: '',
        extra: '',
        community_id: ''
      }, // }}}
      processingForm: false,
      processing: false,
      rules: { // {{{
        birth_date: [v => !!v || 'La fecha de nacimiento  requerido.'],
        legal_representative: [v => !!v || 'El dato sexo requerido.'],
        language_id: [v => !!v || 'Su idioma es requerido es requerido.'],
        email: [
          v => !!v || 'El correo es requerido.',
          v => /.+@.+[a-zA-Z0-9_]/.test(v) || 'E-mail tiene que ser ejemplo@gmail.com.'
        ],
        telephone: [
          v => !!v || 'El telefono es requerido',
          v => /^[0-9]{9}$/.test(v) || 'Ingresar solo numeros y 9 digitos.'
        ],
        telephone_legal_representative: [
          v => !!v || 'El telefono del apoderado es requerido',
          v => /^[0-9]{9}$/.test(v) || 'Ingresar solo numeros y 9 digitos.'
        ]
      } // }}}
    }
  }, // }}}
  watch: {
    'form.birth_region': function (val) {
      this.$refs.ubigeo.form.region = val
    },
    'form.birth_province': function (val) {
      this.$refs.ubigeo.form.province = val
    },
    'form.birth_district_id': function (val) {
      this.$refs.ubigeo.form.district = val
    }
  }
}
</script>
